import { Price } from './Price';

export type { TypePriceProps } from './types';
export default Price;
